import { useTranslation } from 'react-i18next';

export const keyPrefix = 'toggle_top_match';
export const useToggleTopMatchTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    label: 'Отображать наибольшее совпадение',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    label: 'Display top match',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    label: 'Mostrar melhor correspondência',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    label: 'Mostrar mejor coincidencia',
  },
}) : {}) as Record<string, unknown>;
